export const PRODUCT_GAP_FULL_EXPORT_REPORTS = Object.freeze([
  "cancelled_appointments",
  "appointment_schedule",
  "sales_by_type",
  "sales_by_service",
  "sales_by_product",
  "sales_by_staffmember",
  "sales_by_day",
  "gift_voucher_activity",
  "client_list",
  "client_birthdays",
  "clients_by_service",
  "clients_by_product",
  "utilisation",
  "rebooking",
  "subscription",
  "package",
]);

// Client list already exposes its existing bounded "More" navigation. The
// remaining audited reports use the shared numbered-page control.
export const PRODUCT_GAP_PAGE_NAVIGATION_REPORTS = Object.freeze(
  PRODUCT_GAP_FULL_EXPORT_REPORTS.filter((report) => report !== "client_list"),
);

// Most fixed-snapshot reports are paged by Flask. EOD keeps raw pages in its
// response, while its visible Laravel summary covers the full selected day.
const READY_FULL_EXPORT_REPORTS = Object.freeze([
  "gift_vouchers",
  "absent_clients",
  "stock_levels",
  "performance_summary",
  "sales_by_end_of_day",
  "client_retention",
]);

const READY_PAGE_NAVIGATION_REPORTS = Object.freeze([
  "performance_summary",
]);

Object.freeze(["performance_summary", "sales_by_product", "sales_by_staffmember", "cancelled_appointments", "appointment_schedule", "utilisation", "rebooking"]);

export const FULL_EXPORT_REPORTS = Object.freeze([
  ...READY_FULL_EXPORT_REPORTS,
  ...PRODUCT_GAP_FULL_EXPORT_REPORTS,
]);

export const PAGE_NAVIGATION_REPORTS = Object.freeze([
  ...READY_PAGE_NAVIGATION_REPORTS,
  ...PRODUCT_GAP_PAGE_NAVIGATION_REPORTS,
]);

export const isFullExportReport = (report) => FULL_EXPORT_REPORTS.includes(report);
export const isPageNavigationReport = (report) => PAGE_NAVIGATION_REPORTS.includes(report);

export const buildReportListFilters = ({
  report,
  dateRange,
  selectedDate,
  staffId,
  supplierId,
  serviceId,
  productId,
  month,
  customerName,
  voucherStatus,
  voucherSearch,
  finishesWithinMonths,
} = {}) => {
  if (report === "sales_by_end_of_day") {
    return { start_date: selectedDate, end_date: selectedDate, layout: "laravel" };
  }
  return {
    ...(dateRange ? { daterange: dateRange } : {}),
    ...(staffId ? { staff_id: staffId } : {}),
    ...(supplierId ? { supplier_id: supplierId } : {}),
    ...(serviceId ? { service_id: serviceId } : {}),
    ...(productId ? { product_id: productId } : {}),
    ...(month ? { month } : {}),
    ...(typeof customerName === "string" && customerName.trim()
      ? { filter_customer_name: customerName.trim() }
      : {}),
    ...(report === "gift_vouchers" && voucherStatus
      ? { status: voucherStatus }
      : {}),
    ...(report === "gift_vouchers" && typeof voucherSearch === "string" && voucherSearch.trim()
      ? { search: voucherSearch.trim(), search_all_dates: true }
      : {}),
    ...(report === "subscription" && finishesWithinMonths
      ? { finishes_within_months: finishesWithinMonths }
      : {}),
  };
};

export const buildFullReportRequest = (arguments_ = {}) => ({
  ...buildReportListFilters(arguments_),
  pagination: true,
});
